import { render, staticRenderFns } from "./SelectSharer.vue?vue&type=template&id=0cb1e4e9"
import script from "./SelectSharer.vue?vue&type=script&lang=js"
export * from "./SelectSharer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports